import { Component, OnInit } from '@angular/core';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent implements OnInit {

  headingtitle: any;
  notificationList: any;

  constructor(public cmndecl: CommonDeclarationService, public cmndef: CommonDefinitionService) {
    this.cmndecl.getstoreProcess("allnotifications").then(data => {
      console.log(JSON.stringify(data));
      this.notificationList = data;
    });

    this.headingtitle = "Notifications"
    // this.notificationList = {
    //   "openlink": [{
    //     content: "hello how are you",
    //     link: "https://www.google.com",
    //     flg: "active",
    //     time: "22-04-2020 11:46"
    //   }, {
    //     content: "please visit our website",
    //     link: "https://www.google.com",
    //     flg: "active",
    //     time: "22-04-2020 11:46"
    //   }, {
    //     content: "We released a new update. Please check it",
    //     link: "https://www.google.com",
    //     flg: "active",
    //     time: "22-04-2020 11:46"
    //   }],
    //   "reminder": [{
    //     content: "due date reminder",
    //     flg: "active",
    //     time: "22-04-2020 11:46"
    //   }, {
    //     content: "please visit our website",
    //     flg: "active",
    //     time: "22-04-2020 11:46"
    //   }, {
    //     content: "We released a new update. Please check it",
    //     flg: "active",
    //     time: "22-04-2020 11:46"
    //   }],
    //   "datalist": [{
    //     content: "Please check you payment",
    //     flg: "active",
    //     time: "22-04-2020 11:46"
    //   }, {
    //     content: "Your payment due date is already over",
    //     flg: "active",
    //     time: "22-04-2020 11:46"
    //   }, {
    //     content: "Please contact with our branch",
    //     flg: "active",
    //     time: "22-04-2020 11:46"
    //   }]
    // }
  }

  ngOnInit() { }

}
